import { PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MvdModalService } from 'app/shared/services/modal/mvd-modal.service';
import { finalize } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { EmissionAreaType } from '../../titleregistration/models/enums/emission-area-type.enum';
import { AddressService } from '../services/address.service';

/*
// AddressEmissionAreaTypeModal is a separate modal component for selecting and modifying an address's emission area type.
// In this modal, the CSR can change the emission area type independently from the Address Details modal. By splitting this
// functionality into its own modal, any authorized CSR may manually override and adjust emission area types.
*/
export class AddressEmissionAreaTypeModalContext {
    constructor(public addressNumberId: number, public emissionAreaTypeId) { }
}

@Component({
    templateUrl: './address-modal-emission-area-type.html'
})
export class AddressEmissionAreaTypeModalComponent extends BaseComponent implements OnInit {
    private context: AddressEmissionAreaTypeModalContext;

    public addressForm: UntypedFormGroup;
    public emissionAreaTypeLookups = (new EmissionAreaType()).GetAll().map(x => ({ id: x.id, displayValue: x.displayValue }));
    public inProgress = false;
    private originalEmissionAreaTypeId: number;

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<AddressEmissionAreaTypeModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: AddressEmissionAreaTypeModalContext,
        public addressService: AddressService,
        public _fb: UntypedFormBuilder,
        public modalService: MvdModalService
    ) {
        super();
        this.context = this.data;

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    public ngOnInit() {
        this.addressForm = this._fb.group({
            emissionAreaTypeId: new UntypedFormControl(this.context.emissionAreaTypeId, Validators.compose([Validators.required]))
        });

        // Store the original emissionAreaTypeId
        this.originalEmissionAreaTypeId = this.context.emissionAreaTypeId;
    }

    public cancel = (): void => {
        // Reset to the original emission area type id
        this.addressForm.get('emissionAreaTypeId').setValue(this.originalEmissionAreaTypeId);
        this.dialogRef.close(this.originalEmissionAreaTypeId);
    };

    public save(): void {
        if (!this.addressForm.valid) {
            return;
        }

        this.inProgress = true;
        var emissionAreaTypeId = this.addressForm.get('emissionAreaTypeId').value;

        this.addressService.updateEmissionAreaType(this.context.addressNumberId, emissionAreaTypeId)
            .pipe(finalize(() => this.inProgress = false ))
            .subscribe(() => {
                this.dialogRef.close(emissionAreaTypeId);
            }, e => {
                this.handleValidationResult(e);
            });
    }
}
